import { Grid, Typography } from '@mui/material';

const EmptyListMessageBox = ({ message, height, dataId='' }: any) => {
  return (
    <Grid
      item
      container
      sx={{
        display: 'flex',
        height: height ? height : '175px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        borderRadius: '8px',
        background: '#F5F5F5'
      }}
      data-testid={dataId}
      className='empty-list'
    >
      <Typography
        sx={{
          color: '#000',
          fontFamily: 'Inter',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '22px',
          textAlign: 'center'
        }}
      >
        {message}
      </Typography>
    </Grid>
  );
};

export default EmptyListMessageBox;
